import apiClient from '@/plugins/axios';

export default {
	get(id, opts = {}) {
		return apiClient.get(`v1/CustomerLicense/${id}`, opts);
	},

	create(body, opts = {}) {
		return apiClient.post('v1/CustomerLicense', body, opts);
	},

	update(id, body, opts = {}) {
		return apiClient.put(`v1/CustomerLicense/${id}`, body, opts);
	}
};
